<template>
    <v-progress-linear
        :active="apiLoading"
        indeterminate
        top
        color="primary"
        background-color="primary lighten-3"
        stripped
        dark
        style="z-index: 10;"
    />
</template>
<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {};
    },
    computed: mapState(['apiLoading']),
};
</script>
